<template>
  <div>
    <Header page="employee_vendor"/>
    <b-container>
      <b-row class="mt-30">
        <b-col cols="12" lg="3" class="text-center">
          <SidebarVendor />
        </b-col>
        <b-col cols="12" lg="9">
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">所在地</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor" v-if="vendor.zip_code">{{"〒"+vendor.zip_code.slice(0, 3)+"-"+vendor.zip_code.slice(3, 7)+vendor.address}}</div>
              <div class="vendor-content-infor" v-if="!vendor.zip_code">{{vendor.address}}</div>            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">事業内容</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">{{vendor.business_content}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">従業員数</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">{{formatNumber(vendor.number_employees)}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">資本金</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">{{formatNumber(vendor.capital)}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">代表者名</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">{{vendor.representative_name}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">代表電話番号</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">{{vendor.representative_phone}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">メールアドレス</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">{{vendor.representative_email}}</div>
            </b-col>
          </b-row>
          <b-row class="infor-row border-0">
            <b-col cols="4" class="pl-0">
              <div class="vendor-title">ホームページ</div>
            </b-col>
            <b-col cols="8">
              <div class="vendor-content-infor">{{vendor.homepage}}</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SidebarVendor from '@/views/Employee/Company/Sidebar'
import Header from '@/components/share/Header'
import {mapState} from 'vuex'
export default {
  name: 'DetailVendor',
  components: {
    SidebarVendor,
    Header
  },
  data () {
    return {
      items: [
        {
          text: 'ホーム',
          href: '#'
        },
        {
          text: 'LINE GROUP',
          active: true
        }
      ]
    }
  },
  methods: {
  },
  computed: {
    ...mapState({
      vendor: state => state.employeeVendor.vendor
    })
  },
  mounted () {
    this.$store.dispatch('employeeVendor/getVendor')
  }
}
</script>
<style scoped lang="scss">
  @import '@/assets/stylesheet/vendor/detail_vendor.scss';
  @import "@/assets/stylesheet/admin/vendor.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/Company/Detail.vue